/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Extendwrapupseconds2Inputs */

const en_entity_extendwrapupseconds2 = /** @type {(inputs: Entity_Extendwrapupseconds2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Wrap-Up Seconds`)
};

const de_entity_extendwrapupseconds2 = /** @type {(inputs: Entity_Extendwrapupseconds2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachbearbeitungszeit Verlängerungssekunden`)
};

/**
* | output |
* | --- |
* | "Extend Wrap-Up Seconds" |
*
* @param {Entity_Extendwrapupseconds2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_extendwrapupseconds2 = /** @type {((inputs?: Entity_Extendwrapupseconds2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Extendwrapupseconds2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_extendwrapupseconds2(inputs)
	return de_entity_extendwrapupseconds2(inputs)
});
export { entity_extendwrapupseconds2 as "entity_extendWrapupSeconds" }